<template>
  <div class="main-auction">
    <div class="auction-item-page">
      <q-card class="my-card">
        <q-card-section class="card-section">
          <div class="card-title">Auction item Shop</div>
        </q-card-section>
        <q-separator />
        <q-tabs v-model="tab" class="tab-section">
          <q-tab 
            name="2"
            label="Gold Auction"
            @click="tabChange()"
          />
          <q-tab 
            name="1"
            label="EP Auction"
            @click="tabChange()"
          />
        </q-tabs>
        <q-card-section class="search-section">
          <q-input
          v-model="itemName"
          debounce="1000"
          outlined
          rounded
          input-style="font-size:12px"
          color="grey"
          placeholder="Search By Item Name"
          dense
          @update:model-value="requestAuctionItemListLocal(false)"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
        </q-card-section>
        <q-card-section class="card-content">
          <div class="col-item" v-for="(column, index) in itemShopColumn" :key="index">
            <auction-item-slot
              v-for="(auctionItem) in column"
              :key="auctionItem.ProductNum"
              :auctionItemInfo="auctionItem"
              @success-request="requestAuctionItemListLocal(true)"
              @start-bid="(itemDetails) => onStartBid(itemDetails)"
            />
          </div>
        </q-card-section>
        <div class="q-pa-lg flex flex-center pagination">
          <q-pagination
            v-model="pagination.current"
            :max="pagination.last"
            direction-links
            outline
            color="orange"
            active-design="unelevated"
            active-color="brown"
            active-text-color="orange"
            @update:model-value="requestAuctionItemListLocal(false)"
            :max-pages="3"
          />
        </div>
      </q-card>
    </div>
    <auction-details-modal
      :open="openModal"
      :itemDetails="itemDetails"
      @close="openModal = false"
      @success-request = "requestAuctionItemListLocal(true)"
    />
  </div>
</template>
<script>
import AuctionItemSlot from './AuctionItemSlot';
import AuctionDetailsModal from './Modal/AuctionDetailsModal.vue'

import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'AuctionItemPage',
  data () {
    return {
      tab: '2',
      itemName: '',
      column: 2,
      pagination: {
        current: 1,
        last: 1
      },
      itemDetails: null,
      countDown: '',
      timer: null,
      openModal: false
    }
  },
  components: {
    AuctionItemSlot,
    AuctionDetailsModal
  },
  computed: {
    ...mapGetters({
      getAuctionItems: 'auction/getAuctionItems'
    }),
    itemShopColumn () {
      let column = []

      if (this.getAuctionItems) {
        const auctionItem = this.getAuctionItems.data

        if (!auctionItem) return []

        const mid = Math.ceil(auctionItem.length / this.column)

        for (let col = 0; col < this.column; col++) {
          column.push(auctionItem.slice(col * mid, col * mid + mid))
        }
      }

      return column
    }
  },
	async mounted () {
    await this.requestAuctionItemListLocal (false)
	},
	methods: {
		...mapActions({
			requestAuctionItemList: 'auction/requestAuctionItemList'
		}),
    async requestAuctionItemListLocal (clearSearch) {
      this.$q.loading.show()

      if (clearSearch) this.itemName = ''

      const parameter = {
        section: this.tab,
        itemName: this.itemName,
        page: this.pagination.current
      }

      await this.recaptchaLoad('getauctionitem')

      await this.requestAuctionItemList(parameter);

      this.pagination.current = this.getAuctionItems.current_page
      this.pagination.last = this.getAuctionItems.last_page

      this.$q.loading.hide()
    },
    tabChange() {
      this.requestAuctionItemListLocal (false)
    },
    onStartBid (itemDetails) {
      this.itemDetails = itemDetails
      this.openModal = true
    },
  }
}
</script>

<style lang="scss">
.main-auction {
  .auction-item-page {
    .my-card {
      background-color: $backgroundHeader;

      .card-title {
        font-size: 16px;
        font-weight: 700;
      }

      .search-section {
        background-color: $background;

        .q-input {
          max-width: 300px;
          color: white;
          margin-top: 16px;
          margin-bottom: 48px;
          margin-right: 24px;
          margin-left: auto;
        }

        .q-field__inner {
          height: 0px
        }

        .q-field__native, .q-field__input {
          color: white;
          padding: 14px;
        }
        

        .q-field__control {
          max-height: 48px;
          &::after {
            max-height: 48px;
            color: orange;
          }
          
          .q-icon {
            color: grey;
          }
        }
      }

      .tab-section {
        background-color: $background;
        color: white;
      }

      .card-section {
        color: white;
      }

      .card-content {
        background-color: $background;
        display: flex;
        grid-template-rows: 1fr 1fr;
        gap: 16px;

        .class-type {
          img {
            width: 50px;
            height: 50px;
          }
        }

        .col-item {
          width: 50%; 
        }
      }

      .pagination {
        padding: 8px;
        background-color: $background;
      }
    }
  }
}
</style>